
import { defineComponent } from "vue";

import TransportBoxCarCatalogue from "@/components/catalogues/TransportCatalogue/TransportBoxCarCatalogue.vue";

export default defineComponent({
  components: { TransportBoxCarCatalogue },
  props: {},
  methods: {},
  data() {
    return {};
  },
});
